import { motion } from 'framer-motion'

/** Full-bleed animated orbital graphic for heroes. */
export function OrbitField() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
      <div className="afos-grid" />
      <motion.div
        className="absolute -right-24 top-10 h-[520px] w-[520px] rounded-full"
        style={{
          background:
            'conic-gradient(from 120deg, rgba(46,230,197,0.0), rgba(46,230,197,0.35), rgba(255,179,71,0.25), rgba(46,230,197,0.0))',
          filter: 'blur(2px)',
        }}
        animate={{ rotate: 360 }}
        transition={{ duration: 40, repeat: Infinity, ease: 'linear' }}
      />
      <motion.div
        className="absolute left-[-120px] bottom-[-80px] h-[420px] w-[420px] rounded-full border border-[rgba(46,230,197,0.25)]"
        animate={{ rotate: -360 }}
        transition={{ duration: 55, repeat: Infinity, ease: 'linear' }}
      />
      <svg className="absolute right-[8%] top-[18%] h-[380px] w-[380px] opacity-80" viewBox="0 0 400 400">
        <defs>
          <linearGradient id="orbitStroke" x1="0" y1="0" x2="1" y2="1">
            <stop stopColor="#2EE6C5" />
            <stop offset="1" stopColor="#FFB347" />
          </linearGradient>
        </defs>
        <circle cx="200" cy="200" r="150" fill="none" stroke="url(#orbitStroke)" strokeWidth="1.5" strokeDasharray="8 14" />
        <circle cx="200" cy="200" r="110" fill="none" stroke="rgba(157,176,212,0.35)" strokeWidth="1" />
        <circle cx="200" cy="200" r="70" fill="rgba(46,230,197,0.08)" stroke="rgba(46,230,197,0.4)" />
        <motion.circle
          cx="350"
          cy="200"
          r="7"
          fill="#FFB347"
          animate={{ rotate: 360 }}
          style={{ transformOrigin: '200px 200px' }}
          transition={{ duration: 12, repeat: Infinity, ease: 'linear' }}
        />
      </svg>
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[var(--color-void)] to-transparent" />
    </div>
  )
}
